import { render, staticRenderFns } from "./imprimir.vue?vue&type=template&id=4e747246"
import script from "./imprimir.vue?vue&type=script&lang=js"
export * from "./imprimir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports